(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sablier-restock-watcher"] && !Shopify.designMode) return;
  try {
    (function restockWatcher() {
  const start = () => {
    if (window.__sablierRestockWatcher) return;
    window.__sablierRestockWatcher = true;
    const startedAt = Date.now();
    const notices = Array.from(document.querySelectorAll('[data-sablier-countdown][data-product-availability-url]'))
      .map(element => ({
        element, target: Date.parse(element.dataset.countdownTarget),
        threshold: Number(element.dataset.countdownStartWithinMs || 86400000),
        label: element.dataset.countdownLabel || element.textContent.trim(),
        variantId: element.dataset.productVariantId,
      })).filter(notice => Number.isFinite(notice.target));
    if (!notices.length) return;
    let reloading = false;
    const reload = (reason, key) => {
      if (reloading) return;
      try {
        const storageKey = `sablier-restock:${reason}:${key}`;
        const previous = Number(window.sessionStorage.getItem(storageKey) || 0);
        if (previous && (reason === 'zero' || Date.now() - previous < 60000)) return;
        window.sessionStorage.setItem(storageKey, String(Date.now()));
      } catch {}
      reloading = true;
      window.location.reload();
    };
    const pad = value => String(value).padStart(2, '0');
    const render = () => {
      const now = Date.now();
      notices.forEach(notice => {
        const {element, target, threshold, label} = notice;
        if (!element.isConnected) return;
        const remaining = target - now;
        if (remaining > threshold) {
          element.textContent = label;
        } else if (remaining > 0) {
          const seconds = Math.ceil(remaining / 1000);
          element.setAttribute('role', 'timer');
          element.setAttribute('aria-live', 'off');
          element.textContent = `${pad(Math.floor(seconds / 3600))}H ${pad(Math.floor(seconds / 60) % 60)}M ${pad(seconds % 60)}S`;
        } else {
          element.textContent = element.dataset.countdownComplete || label;
          if (startedAt < target) reload('zero', target);
        }
      });
    };
    const products = new Map();
    notices.forEach(notice => {
      const url = notice.element.dataset.productAvailabilityUrl;
      if (!products.has(url)) products.set(url, {notices: [], checking: false, nextCheck: 0});
      products.get(url).notices.push(notice);
    });
    const checkProduct = async (url, product, force) => {
      if (document.hidden || reloading || product.checking) return;
      if (!force && Date.now() < product.nextCheck) return;
      const activeNotices = product.notices.filter(notice => notice.element.isConnected);
      if (!activeNotices.length) return;
      product.checking = true;
      const nearRestock = activeNotices.some(notice => notice.target - Date.now() <= notice.threshold);
      product.nextCheck = Date.now() + (nearRestock ? 15000 : 60000);
      try {
        const separator = url.includes('?') ? '&' : '?';
        const response = await fetch(`${url}${separator}_=${Date.now()}`, {
          headers: {Accept: 'application/json'}, cache: 'no-store',
          signal: AbortSignal.timeout(10000),
        });
        if (!response.ok) return;
        const data = await response.json();
        let available = false;
        activeNotices.forEach(notice => {
          const variant = notice.variantId && Array.isArray(data.variants)
            ? data.variants.find(item => String(item.id) === notice.variantId) : null;
          const inStock = notice.variantId ? variant?.available === true : data.available === true;
          if (!inStock) return;
          available = true;
          notice.element.closest('.sablier-bis-copy, .sablier-oos-eta')?.remove();
        });
        if (available) reload('stock', url);
      } catch {} finally {
        product.checking = false;
      }
    };
    const checkAll = (force = false) => {
      products.forEach((product, url) => { checkProduct(url, product, force); });
    };
    render();
    checkAll();
    window.setInterval(render, 1000);
    window.setInterval(checkAll, 15000);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) return;
      render();
      checkAll(true);
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      render();
      checkAll(true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
